import React, { useCallback, useState } from "react";
import "./index.scss";
import { Modal, Row, Col } from "reactstrap";
import CustomTextInput from "components/CustomTextInput";
import { Button } from "shared";
import moment from "moment";

type ModalIFRSReportProps = {
  isOpen: boolean;
  toggle: () => void;
  startDate: string;
  endDate: string;
  onRunReport: (data: any) => void;
};

const ModalIFRSReport = ({
  isOpen,
  toggle,
  startDate,
  endDate,
  onRunReport,
}: ModalIFRSReportProps) => {
  const [data, setData] = useState({
    from_date: moment(startDate || new Date())
      .startOf("month")
      .format("YYYY-MM-DD"),
    to_date: moment(endDate || new Date())
      .startOf("month")
      .format("YYYY-MM-DD"),
    version_calculation_note: "",
  });

  const updateAtt = useCallback((att: string, value: any) => {
    setData(current => ({
      ...current,
      [att]: value,
    }));
  }, []);

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <div className="ifrs-report__header">
        <span className="ifrs-report__title">IFRS Report Run</span>
      </div>
      <div className="ifrs__body">
        <Row>
          <Col sm={{ size: 6, offset: 0 }}>
            <CustomTextInput
              type="date"
              callback={updateAtt}
              data={data}
              labelText="From date"
              attributeName="from_date"
              showMonthYearOnly
            />
          </Col>
          <Col sm={{ size: 6, offset: 0 }}>
            <CustomTextInput
              type="date"
              callback={updateAtt}
              data={data}
              labelText="To date"
              attributeName="to_date"
              showMonthYearOnly
            />
          </Col>
        </Row>
        <Row>
          <Col sm={{ size: 12, offset: 0 }}>
            <CustomTextInput
              type="textarea"
              callback={updateAtt}
              data={data}
              labelText="Note"
              attributeName="version_calculation_note"
            />
          </Col>
        </Row>
      </div>
      <div className="ifrs__footer">
        <Button label="Cancel" onClick={toggle} />
        <div style={{ width: 10 }} />
        <Button
          label="Run report"
          type="primary"
          onClick={() => onRunReport(data)}
        />
      </div>
    </Modal>
  );
};

export default ModalIFRSReport;
